import moment from "moment"

/**
 * Convierte un string ISO (YYYY-MM-DD) a MM/DD/YYYY para mostrar.
 */
export const formatDisplayDate = (date: string | null | undefined): string => {
  if (!date) return ""
  return moment(date, "YYYY-MM-DD", true).isValid()
    ? moment(date).format("MM/DD/YYYY")
    : date
}

/**
 * Convierte un objeto Date a:
 * - display (MM/DD/YYYY) para UI
 * - iso (YYYY-MM-DD) para guardar
 */
export const formatDateForSave = (date: Date | null): { display: string; iso: string } => {
  if (!date) return { display: "", iso: "" }
  return {
    display: moment(date).format("MM/DD/YYYY"),
    iso: moment(date).format("YYYY-MM-DD"),
  }
}

/**
 * Convierte ISO a objeto Date para DatePicker
 */
export const parseISOToDate = (iso: string | null | undefined): Date | null => {
  return iso ? moment(iso, "YYYY-MM-DD").toDate() : null
}